import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const config = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID,
  measurementId: process.env.VUE_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID,

  clientId: process.env.VUE_APP_CLIENT_ID,
  scope: 'https://www.googleapis.com/auth/drive',
  discoveryDocs: [ 'https://sheets.googleapis.com/$discovery/rest?version=v4',
    'https://www.googleapis.com/discovery/v1/apis/drive/v2/rest' ]
}

export function initFirebase () {
  firebase.initializeApp(config)
  var provider = new firebase.auth.GoogleAuthProvider()
  // see scopes: https://developers.google.com/sheets/api/guides/authorizing
  provider.addScope(config.scope)
}

export function initFirestore () {
  const db = firebase.firestore()
  db.enablePersistence({ synchronizeTabs: true })
    .catch(e => console.error(`Enabling offline persistence failed: ${e}`))
  return db
}

export async function signIn () {
  var provider = new firebase.auth.GoogleAuthProvider()
  provider.addScope(config.scope)
  return (await firebase.auth().signInWithPopup(provider)).user
}

export function signOut () {
  return firebase.auth().signOut()
    .then(() => { console.log('Logged out') })
    .catch(error => { console.error(error) })
}
